export const LINE_GAP = 10;
export const BOLD_LINE_INDEX = 5;

export const WATER_MARKS_HORIZONTAL_COUNT = 5;
export const WATER_MARKS_VERTICAL_COUNT = 4;

export const FRONT_EDITOR_TOOLS_WIDTH = 200;
export const FRONT_EDITOR_TOOLS_HEIGHT = 70;
export const SIDE_EDITOR_TOOLS_WIDTH = 200;
export const SIDE_EDITOR_TOOLS_HEIGHT = 70;
export const TOP_EDITOR_TOOLS_WIDTH = 125;
